module.exports = __webpack_public_path__ + "img/@work_img2.cb8f571c.jpg";